import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    user: null,
    users: [],
  },
  getters: {
    isInitialized: state => state.isInitialized,
    user: state => state.user,
  },
  mutations: {
    setUser: (state, payload) => {
      state.user = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["workos/isInitialized"]);

      var userId = context.rootGetters["userId"];
      if (!userId) {
        context.commit("setUser", null);
        return;
      }

      await axios
        .get(`/v1/users/${userId}`)
        .then(res => context.commit("setUser", res.data))
        .catch(() => context.commit("setUser", null));
    },
    // Records an explicit UI choice for the signed-in user ("react" | "legacy" | null to
    // fall back to the organization default). The escape hatch works in both directions:
    // choosing react here is what makes the choice stick, and the React console writes
    // "legacy" when the user switches back, so the auto-redirect guard leaves them alone.
    //
    // Deliberately does not commit the new value into state: every caller follows this
    // with a full page load into the other app, which refetches the user and organization
    // payloads anyway.
    setPreferredUi: async (context, preferredUi) => {
      var user = context.getters["user"];
      if (!user) return;

      await axios.put(`/v1/users/${user.id}/preferred-ui`, { preferredUi });
    },
  },
};
